export default "__VITE_ASSET__Gmk02g4T__"